import { ENTER, COMMA } from '@angular/cdk/keycodes';

export const CONSTANTS = {
  OTHER_GENDER_ID: -1,
  OTHER_INDIGENOUS_ID: -1,
  OTHER_RACE_ID: -1,
  SEPARATOR_KEYS_CODES: [ENTER, COMMA],
  STUDENT_OBJ_STORAGE_KEY: 'data-works-student-object',
  ENVELOPE_STORAGE_KEY: 'envelope',
  OUT_OF_COUNTRY: 'Out of the country',
};
